import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container border" }
const _hoisted_2 = { clas: "row" }

import { ref, watch } from 'vue';

import FormInput from '@/components/modals/FormInputV2.vue';
import APIDataResult from '@/components/modals/APIDataResult.vue';

import { useAPI } from '@/composables/useAPI';
import { updateUser } from '@/aux/trouble_report';
import { EUpdateStates } from '@/aux/enums';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyView',
  setup(__props) {

const t = ref<string>('');
const u = ref<number>(0);
const v = ref<number>(0);

const { apiResult, callAPI } = useAPI();

const handleSubmit = () => {
  callAPI(updateUser, '635ac0222bf5526e48c776df', { first_name: t.value });
};

watch(
  () => apiResult.value.state,
  (updateState) => {
    if (updateState === EUpdateStates.SUCCESS) {
      t.value = '';
      u.value += 1;
    }
  }
);

/*
onBeforeMount(async () => {
  x.value = (
    await axios.post('http://localhost:8000/external/get-aircraft-data', {
      token:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MzVhYzAyMzJiZjU1MjZlNDhjNzc2ZWMiLCJjbGllbnRTZXJ2ZXIiOiJodHRwOi8vbG9jYWxob3N0OjgwODAiLCJpYXQiOjE2NzA2MjI0NzQsImV4cCI6MTY3MDcwODg3NH0.CPEZ8VdAGcDJgshkwb-VUxSnYr28zQnvH-LtPYpOV8c',
    })
  ).data;
});
*/

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(APIDataResult, {
      modelValue: _unref(apiResult),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(apiResult) ? (apiResult).value = $event : null))
    }, {
      successMessage: _withCtx(() => [
        _createTextVNode(" Data updated! ")
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(FormInput, {
        value: t.value,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((t).value = $event)),
        inputType: "text",
        label: "Test Label",
        requiredInput: true,
        inputElementIsDisabled: false,
        inputIsValid: t.value.length > 3,
        resetValidation: u.value,
        onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (v.value += 1), ["enter"]))
      }, null, 8, ["value", "inputIsValid", "resetValidation"])
    ]),
    _createElementVNode("div", { class: "row" }, [
      _createElementVNode("div", { class: "col" }, [
        _createElementVNode("button", {
          type: "button",
          onClick: handleSubmit
        }, "Submit")
      ])
    ])
  ]))
}
}

})